import React, { useState } from "react";
import Modal from "react-modal";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../Components/ComponentCss/ExitProcessingModal.css";
import axios from "axios";
import config from "../ip.json";
import Swal from "sweetalert2";


const ExitProcessingModal = ({ isOpen, closeModal, companyName, roomArray }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedRoom, setSelectedRoom] = useState("");

    const handleRoomSelect = (room) => {
        setSelectedRoom(room);
    };

    const handleExitProcessing = async () => {
        if (!selectedDate || !selectedRoom) {
            alert("퇴실일자와 호실을 선택해주세요.");
            return;
        }
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1
        const day = String(selectedDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        // alert(selectedRoom + formattedDate);
        //
        // // 날짜를 YYYY-MM-DD 형식으로 변환
        // alert(`퇴실 처리\n호실: ${selectedRoom}\n퇴실일자: ${formattedDate}`);
        if (roomArray.length-1===0) {
            isRoomLengthZero()
        }else{
            const jwtToken = sessionStorage.getItem("Authorization");


            try {
                const response = await axios.get(config.url + "/v2/payment/checkout", {
                    params: {
                        roomNumber: String(selectedRoom),
                        date: formattedDate, // 변환된 날짜를 전달
                    },
                    headers: {
                        Authorization: jwtToken,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true, // 쿠키 필요 시 설정
                });

                console.log(response.data); // 콘솔로 데이터 확인
                퇴실성공();

            } catch (error) {
                console.error("Error fetching data:", error);
                퇴실실패();
            }
        }



        closeModal();
    };


    const isRoomLengthZero = () => {
        Swal.fire({
            title: "기업도 같이 삭제 하시겠습니까?",
            text: "해당 호실을 퇴실처리하면, 사용호실이 0개 입니다.",
            icon: "question",
            showCancelButton: true,
            showDenyButton: true,
            denyButtonText: "호실만 삭제",
            confirmButtonText: "기업도 같이 삭제",

            cancelButtonText: "취소하기",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const year = selectedDate.getFullYear();
                const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1
                const day = String(selectedDate.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${day}`;



                const jwtToken = sessionStorage.getItem("Authorization");


                try {
                    const response = await axios.get(config.url + "/v2/company/delete", {
                        params: {
                            name: companyName,
                            date: formattedDate, // 변환된 날짜를 전달
                        },
                        headers: {
                            Authorization: jwtToken,
                            "Content-Type": "application/json",
                        },
                        withCredentials: true, // 쿠키 필요 시 설정
                    });

                    console.log(response.data); // 콘솔로 데이터 확인
                    퇴실성공();                    closeModal();


                } catch (error) {
                    console.error("Error fetching data:", error);
                    퇴실실패();                    closeModal();

                }
                window.location.reload();

                setTimeout(() => {
                    Swal.fire("완료!", "기업 및 호실이 모두 퇴실처리 되었습니다!", "success");

                }, 1000); // 1초 딜레이

                closeModal();


            } else if (result.isDenied) {


                const year = selectedDate.getFullYear();
                const month = String(selectedDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1
                const day = String(selectedDate.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${day}`;
                const jwtToken = sessionStorage.getItem("Authorization");


                try {
                    const response = await axios.get(config.url + "/v2/payment/checkout", {
                        params: {
                            roomNumber: String(selectedRoom),
                            date: formattedDate, // 변환된 날짜를 전달
                        },
                        headers: {
                            Authorization: jwtToken,
                            "Content-Type": "application/json",
                        },
                        withCredentials: true, // 쿠키 필요 시 설정
                    });

                    console.log(response.data); // 콘솔로 데이터 확인
                    퇴실성공();
                    closeModal();


                } catch (error) {
                    console.error("Error fetching data:", error);
                    퇴실실패();
                    closeModal();

                }
                Swal.fire("퇴실처리 되었습니다!", "","success");
                closeModal();



            }
        });

    };

    const 퇴실성공 = () => {
        Swal.fire({
            title: "퇴실 처리 되었습니다.",
            icon: "success"
        });
    };

    const 퇴실실패 = () => {
        Swal.fire({
            title: "퇴실 처리에 실패했습니다.",
            icon: "error"
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="기업 퇴실 처리 모달"
            className="exit-modal"
            overlayClassName="exit-modal-overlay"
        >
            <div className="exit-modal-content">
                <h2>기업 퇴실 처리</h2>
                <div className="exit-modal-print-component">
                    <div className="exit-modal-company-name">기업명</div>
                    <div>{companyName}</div>
                </div>

                <div>
                    <div className="exit-modal-company-name">퇴실 호실 선택</div>
                    {roomArray.map((room) => (
                        <div className="exit-modal-select-room" key={room}>
                            <input
                                type="radio"
                                id={`room-${room}`}
                                name="room"
                                value={room}
                                onChange={() => handleRoomSelect(room)}
                                checked={selectedRoom === room}
                            />
                            <label htmlFor={`room-${room}`}>{room}</label>
                        </div>
                    ))}
                </div>
                <div>
                    <div className="exit-modal-company-name">퇴실 일자 선택</div>
                    <Calendar
                        onChange={setSelectedDate}
                        value={selectedDate}
                        locale="ko" // 한국어로 변경
                    />
                </div>
                <div className="exit-modal-buttons">
                    <button onClick={closeModal}>취소</button>
                    <button onClick={handleExitProcessing}>퇴실 처리</button>
                </div>
            </div>
        </Modal>
    );
};

export default ExitProcessingModal;